app.mediator.registerModule(MODULE_NAME__COLLAPSIBLE_PANEL, function (app) {

    var collapsiblePanel = function (toggleButtonElement) {

        //==========================================================xdiv2====
        // Variables 
        //===================================================================

        var scope = this;
        var $toggleButtonElement = $(toggleButtonElement);
        var modelId = $toggleButtonElement.data('collapsible-panel-button-name');
        var $btn = $($('*[data-collapsible-panel-button-name="' + modelId + '"]').get(0));
        var $panel = $($('*[data-collapsible-panel-panel-name="' + modelId + '"]').get(0));

        //==========================================================xdiv2====
        // Module
        //===================================================================

        function toggleCollapsiblePanel() {
            if ($panel.hasClass('hidden-tac')) {
                showCollapsiblePanel();
            } else {
                hideCollapsiblePanel();
            }
        }

        function showCollapsiblePanel() {
            $btn.find('.show-text').attr('aria-hidden', 'true');
            $btn.find('.hide-text').removeAttr('aria-hidden');
            $btn.addClass('showing');
            $panel.removeClass('hidden-tac').removeAttr('aria-hidden');
        }

        function hideCollapsiblePanel() {
            $btn.find('.hide-text').attr('aria-hidden', 'true');
            $btn.find('.show-text').removeAttr('aria-hidden');
            $btn.removeClass('showing');
            $panel.addClass('hidden-tac').attr('aria-hidden', 'true');
        }

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        $toggleButtonElement.click(function (e) {
            e.preventDefault();
            toggleCollapsiblePanel();
        });
      
    };

    return {

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {
            var $toggleElements = $('*[data-collapsible-panel-button-name]');
            $toggleElements.each(function (key, toggleElement) {
                collapsiblePanel(toggleElement);
            });
            app.mediator.notify(EVENT_NAME__COLLAPSIBLE_PANEL__INITIATED);
        }
    };
});